import { type ReactNode, useState } from 'react';

// Favicon requests go through Google's favicon service, which leaks visited domains.
// Proxying through our backend would fix this (used in reasoning panel and settings-privacy-controls).
type FaviconProps = {
  domain: string;
  className?: string;
  fallback?: ReactNode;
};

export const Favicon = ({
  domain,
  className = 'size-4 shrink-0 rounded-sm',
  fallback = null,
}: FaviconProps) => {
  const [hasError, setHasError] = useState(false);

  if (hasError) return <>{fallback}</>;

  return (
    <img
      src={`https://www.google.com/s2/favicons?domain=${encodeURIComponent(domain)}&sz=32`}
      alt=""
      className={className}
      onError={() => setHasError(true)}
    />
  );
};
